import DataList from "components/datatable/DataList";
import React, { useMemo } from "react";
import useAxios from "hooks/useAxios";
import useAxiosFunction from "hooks/useAxiosFunction";
import { useAuth } from "context/AuthProvider";
import { RuleRequired } from "utils/MyUtils";
import { boolText, hasPermission, parseIDList, showEmpty } from "./SystemPageUtils";

export default function GroupManagementPage() {
  const { user } = useAuth();
  const [permissionsResp] = useAxios({
    method: "GET",
    url: "/system/admin/permissions",
    params: { perpage: 500 },
    auth: true,
  });
  const [, , , axiosFetch] = useAxiosFunction();
  const canManage = hasPermission(user, "system.group.manage");
  const permissions = Array.isArray(permissionsResp?.data) ? permissionsResp.data : [];

  const coltype = useMemo(
    () => ({
      id_group: { type: "hidden", name: "id_group" },
      groupname: { label: "Group", type: "text", name: "groupname", colsize: 4, validation: RuleRequired, width: 220 },
      description: { label: "Deskripsi", type: "textarea", name: "description", colsize: 8, renderFunc: (val) => showEmpty(val) },
      permission_ids: {
        label: "Assign Permission",
        type: "listcheckbox",
        name: "permission_ids",
        colsize: 12,
        checklist: permissions,
        valueId: "id_permission",
        labelId: "permission_name",
        itemcolsize: 4,
      },
      total_permissions: { label: "Permission", align: "center", renderFunc: (val) => showEmpty(val, "0"), width: 110 },
      total_menus: { label: "Menu", align: "center", renderFunc: (val) => showEmpty(val, "0"), width: 90 },
      is_active: { label: "Status", type: "checkbox", name: "is_active", renderFunc: (val) => boolText(val), colsize: 2, width: 120 },
      action: { label: "Aksi", align: "center", width: 100 },
    }),
    [permissions]
  );

  const saveGroup = async (form, defaultValue = {}) => {
    const id = form?.id_group || defaultValue?.id_group || "";
    const method = id ? "PUT" : "POST";
    const url = id ? `/system/groups/${id}` : "/system/groups";

    return axiosFetch({
      method,
      url,
      auth: true,
      data: {
        groupname: form.groupname,
        description: form.description || "",
        is_active: Boolean(form.is_active),
        permission_ids: parseIDList(form.permission_ids),
      },
    });
  };

  return (
    <DataList
      title="Daftar Group"
      coltype={coltype}
      dlist={{
        url: "/system/groups",
        columns: ["no", "groupname", "description", "total_permissions", "total_menus", "is_active", "action"],
        filter: [{ dtype: "q", name: "q", colsize: 4 }],
        sort_by: ["groupname", "description"],
      }}
      addconfig={canManage ? {
        columns: ["groupname", "description", "is_active", "permission_ids"],
        title: "Penambahan Group",
        label_tool: "Tambah Group",
        saveHandle: saveGroup,
      } : null}
      editconfig={canManage ? {
        columns: ["id_group", "groupname", "description", "is_active", "permission_ids"],
        title: "Perubahan Group",
        url: "/system/groups",
        urlitem: "/system/groups",
        cellid: "id_group",
        saveHandle: saveGroup,
        normalizeItem: (item) => ({
          ...item,
          permission_ids: parseIDList(item?.permission_ids),
        }),
      } : null}
      delconfig={canManage ? {
        url: "/system/groups",
        cellid: "id_group",
        cellname: "groupname",
      } : null}
    />
  );
}
